export default __webpack_public_path__ + "static/media/kyc-upload-cloud.fcd420da.svg";